<template>
  <header class="page-header">
    <div class="page-header__heading">
      <button
        v-if="showBack"
        type="button"
        class="ui-button ui-button--quiet page-header__back"
        aria-label="Go back"
        @click="$emit('back')"
      >
        <span aria-hidden="true">←</span> Back
      </button>
      <p v-if="eyebrow" class="page-header__eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <p v-if="description" class="page-header__description">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup>
defineProps({
  eyebrow: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  showBack: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['back'])
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  padding-bottom: var(--space-6);
}

.page-header__heading {
  max-width: 50rem;
}

.page-header__eyebrow {
  margin: 0 0 var(--space-2);
  color: var(--accent-strong);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h1 {
  margin: 0;
  font-family: var(--font-academic);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1.05;
}

.page-header__description {
  margin: var(--space-3) 0 0;
  color: var(--ink-muted);
  font-size: 1rem;
}

.page-header__back {
  margin: 0 0 var(--space-3);
  padding-left: 0;
}

.page-header__actions {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: var(--space-2);
}

@media (max-width: 767px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
